export default "__VITE_ASSET__49047548__"